import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'deviationContextName',
    standalone: false
})
export class DeviationContextNamePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'PickUp':
        return 'Henting';
      case 'Delivery':
        return 'Levering';
      default:
        return value;
    }
  }
}
